import { VentilatorConstants } from '../store/ventilator.constants'

export const ventilatorSchemas = [
  {
    inputKey: VentilatorConstants.SET_MODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MODE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MODE'],
    errorMessage: {
      properties: {
        SET_MODE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: VentilatorConstants.SET_BREATH_TYPE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_BREATH_TYPE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_BREATH_TYPE'],
    errorMessage: {
      properties: {
        SET_BREATH_TYPE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: VentilatorConstants.SET_TIDAL_VOLUME,
    isNumber: true,
    type: 'object',
    properties: {
      SET_TIDAL_VOLUME: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_TIDAL_VOLUME'],
  },

  {
    inputKey: VentilatorConstants.SET_PEEP,
    isNumber: true,
    type: 'object',
    properties: {
      SET_PEEP: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_PEEP'],
  },
  {
    inputKey: VentilatorConstants.SET_FIO2,
    isNumber: true,
    type: 'object',
    properties: {
      SET_FIO2: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_FIO2'],
  },
  {
    inputKey: VentilatorConstants.SET_AIR_TEMPERATURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_AIR_TEMPERATURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_AIR_TEMPERATURE'],
  },
  {
    inputKey: VentilatorConstants.SET_PRESSURE_SUPPORT,
    isNumber: true,
    type: 'object',
    properties: {
      SET_PRESSURE_SUPPORT: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_PRESSURE_SUPPORT'],
  },
  {
    inputKey: VentilatorConstants.SET_FLOW_RATE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_FLOW_RATE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_FLOW_RATE'],
  },
  {
    inputKey: VentilatorConstants.SET_SENSITIVITY,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SENSITIVITY: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_SENSITIVITY'],
  },
  {
    inputKey: VentilatorConstants.SET_MEAN_AIRWAY_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_MEAN_AIRWAY_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_MEAN_AIRWAY_PRESSURE'],
  },
  {
    inputKey: VentilatorConstants.SET_HERTZ,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HERTZ: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_HERTZ'],
  },
  {
    inputKey: VentilatorConstants.SET_INO,
    isNumber: true,
    type: 'object',
    properties: {
      SET_INO: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_INO'],
  },
  {
    inputKey: VentilatorConstants.SET_PEAK_INSP_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_PEAK_INSP_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_PEAK_INSP_PRESSURE'],
  },
  {
    inputKey: VentilatorConstants.SET_PLATEAU_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_PLATEAU_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_PLATEAU_PRESSURE'],
  },
  {
    inputKey: VentilatorConstants.SET_AUTO_PEEP,
    isNumber: true,
    type: 'object',
    properties: {
      SET_AUTO_PEEP: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_AUTO_PEEP'],
  },
  {
    inputKey: VentilatorConstants.SET_MINUTE_VENT,
    isNumber: true,
    type: 'object',
    properties: {
      SET_MINUTE_VENT: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_MINUTE_VENT'],
  },
  {
    inputKey: VentilatorConstants.SET_EXHALED_TIDAL_VOLUME,
    isNumber: true,
    type: 'object',
    properties: {
      SET_EXHALED_TIDAL_VOLUME: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_EXHALED_TIDAL_VOLUME'],
  },
  {
    inputKey: VentilatorConstants.SET_ET_CUFF_PRESSURE_MEASUREMENT,
    isNumber: true,
    type: 'object',
    properties: {
      SET_ET_CUFF_PRESSURE_MEASUREMENT: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_ET_CUFF_PRESSURE_MEASUREMENT'],
  },
  {
    inputKey: VentilatorConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: VentilatorConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const ventilatorSecondsSchemas = [
  {
    inputKey: VentilatorConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
